import { config } from '@/config.js';

/**
 * Notes Service
 * Handles API calls for TripCircuit notes management using HuddleLabs API
 * Here are 4 different ways to call GET APIs in your project:
 */

export default class NotesService {
  constructor(app) {
    this.app = app;
  }

  /**
   * Get all notes for a given account
   * @param {string} accountId - The account ID
   * @returns {Promise<Object>} API response with notes data
   */
  async getAllNotes(accountId) {
    try {
      return await this.app.huddleLabsServerCall('profile/account-notes/list', {accountId});
    } catch (error) {
      console.error('Error fetching notes:', error);
      return {
        error: true,
        status: error.status,
        message: error.message
      };
    }
  }

  /**
   * Save or update a note (convenience method)
   * @param {Object} noteData - The note data to save
   * @param {string} noteData.section - The section key
   * @param {string} noteData.content - The note content (HTML)
   * @param {boolean} noteData.isActive - Whether the note is active
   * @returns {Promise<Object>} API response
   */
  async saveNote(noteData) {
    try {
      return await this.app.huddleLabsServerCall(`profile/account-notes`, noteData);
    } catch (error) {
      console.error('Error saving note:', error);
      throw error;
    }
  }
}
